import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBu78E5n17Rc9zydJj6XjVO6d66J6xbe8c",
  authDomain: "go-getter-discovery.firebaseapp.com",
  projectId: "go-getter-discovery",
  storageBucket: "go-getter-discovery.firebasestorage.app",
  messagingSenderId: "166637480011",
  appId: "1:166637480011:web:54c89d22936ec078ce85ce"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);